import React from 'react';
import LoginForm from '../components/forms/LoginForm';
import { apiIsLoggedIn } from '../api/api';

class CreateAccountLandingPage extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
            apiIsLoggedIn().then(isLoggedIn => {
                if (isLoggedIn) {
                    window.location.href = '/';
                }
            });
    }

    render() {
        return (
            <div className="create-account-landing-page">
                Account successfully created!
                Please check your email for a confirmation link. If you do not see it, please check your spam folder. If you still do not see it, please contact <a href="mailto:ramsey.opp@gmail.com">ramsey.opp@gmail.com</a>.

                Once you confirm your email, you can log in below:
                <LoginForm />
            </div>
        );
    }
}

export default CreateAccountLandingPage;
